/**
 * This function is used for creating valid HTML classes. It accepts either strings or arrays as parameters.
 * If a parameter is of type `Array` it has to have the following structure: `[condition, classString, alternativeClassString]`.
 * In that case the `classString` will be set if the condition returns `true`otherwise the `alternativeClassString`will be set.
 *
 * @example generateClassString('exampleClass1', 'exampleClass2')
 *  => 'exampleClass1 exampleClass2'
 * @example generateClassString('exampleClass1', [false, 'exampleClass2', 'exampleClass3'])
 *  => 'exampleClass1 exampleClass3'
 * @example generateClassString('exampleClass1', [false, 'exampleClass2'])
 *  => 'exampleClass1'
 *
 * @param  {...any} args
 * @returns {string} HTML class string
 * @author Lukas Handrick
 */
export function generateClassString(...args) {
    if (args.length === 0) {
        return null;
    }

    const classArray = [];

    if (Array.isArray(args)) {
        const functionArguments = args.filter(argument => !!argument);

        functionArguments.forEach(argument => {
            if (typeof argument === 'string') {
                classArray.push(argument.trim());
            } else if (Array.isArray(argument)) {
                const [condition, classString, altClassString] = argument;

                if (typeof condition !== 'undefined' && condition !== null) {
                    let check;

                    if (typeof condition === 'function') {
                        check = condition();
                    } else {
                        check = condition;
                    }

                    if (check !== null) {
                        classArray.push(check ? (classString ?? '') : (altClassString ?? ''));
                    }
                }
            }
        })

        /*
            Create a set of the classArray and spread it to a new array,
            to make sure there are no duplicate classes
        */
        const htmlClassString = [...new Set(classArray)].join(' ').trim();

        return htmlClassString ?? null;
    }

    return null;
}